export default "__VITE_ASSET__Dm26tnJO__"